<ion-content>
  <!-- Safe Area Container -->
  <div class="safe-area-container">
    <!-- Back Button 
    <ion-button 
      fill="clear" 
      class="back-button"
      (click)="goBack()">
      <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
    </ion-button>-->

    <!-- Native Language Selector - Top Right -->
    <div class="native-selector">
      <ion-select 
        [(ngModel)]="selectedNativeLanguage" 
        (ionChange)="onNativeLanguageChange()"
        interface="popover"
        mode="md"
        placeholder="Select Language">
        <ion-select-option *ngFor="let lang of nativeLanguages" [value]="lang.code">
          {{ getSpeakTextForLanguage(lang.code) }}
        </ion-select-option>
      </ion-select>
    </div>

    <!-- Main Content -->
    <div class="main-content">
      <!-- Main Headline -->
      <h1 class="main-headline" *ngIf="isLanguageInitialized">{{ getMainHeadlineText() }}</h1>
      
      <!-- Loading state for headline -->
      <div class="loading-headline" *ngIf="!isLanguageInitialized">
        <ion-skeleton-text animated style="width: 60%; height: 3rem; margin: 0 auto 40px auto;"></ion-skeleton-text>
      </div>

      <!-- Target Languages Grid -->
      <div class="languages-grid">
        <ion-button 
          *ngFor="let lang of targetLanguages" 
          [fill]="selectedTargetLanguage === lang.code ? 'solid' : 'outline'"
          [color]="selectedTargetLanguage === lang.code ? 'primary' : 'medium'"
          class="language-button"
          (click)="selectTargetLanguage(lang.code)">
          <div class="language-content">
            <img 
              class="flag-image" 
              [src]="lang.flag" 
              [alt]="lang.name + ' flag'"
              (error)="onImageError($event, lang.code)" />
            <div class="language-name">{{ lang.name }}</div>
          </div>
        </ion-button>
      </div>

      <!-- Next Button -->
      <ion-button 
        *ngIf="selectedTargetLanguage"
        expand="block"
        color="success"
        class="next-button"
        (click)="goToLevel()">
        {{ 'BEGINNING.NEXT' | translate }}
        <ion-icon name="arrow-forward" slot="end"></ion-icon>
      </ion-button>
    </div>
  </div>
</ion-content>